import React, { useState, useEffect } from 'react';

export default function AdminNewsPage() {
  const [news, setNews] = useState([]);
  const [form, setForm] = useState({
    title: '',
    summary: '',
    content: '',
    category: '',
    image: ''
  });
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    fetch('/api/news')
      .then(res => res.json())
      .then(data => setNews(data));
  }, []);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));

    const formData = new FormData();
    formData.append('file', file);

    const res = await fetch('/api/news/upload-thumbnail', {
      method: 'POST',
      body: formData
    });

    const data = await res.json();
    setForm(prev => ({ ...prev, image: data.url }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await fetch('/api/admin/news', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });

    setForm({ title: '', summary: '', content: '', category: '', image: '' });
    setPreview(null);

    const updated = await fetch('/api/news').then(res => res.json());
    setNews(updated);
  };

  const handleDelete = async (id) => {
    await fetch(`/api/admin/news/${id}`, { method: 'DELETE' });
    setNews(news.filter(n => n._id !== id));
  };

  return (
    <div className="container py-5">
      <h2 className="mb-4">Manage News</h2>

      <form onSubmit={handleSubmit} className="mb-5">
        <input type="text" placeholder="Title" className="form-control mb-2"
          value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />

        <textarea placeholder="Summary" className="form-control mb-2"
          value={form.summary} onChange={e => setForm({ ...form, summary: e.target.value })}></textarea>

        <textarea placeholder="Content" className="form-control mb-2"
          value={form.content} onChange={e => setForm({ ...form, content: e.target.value })}></textarea>

        <input type="text" placeholder="Category" className="form-control mb-2"
          value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} />

        <label className="form-label">Thumbnail Image</label>
        <input type="file" className="form-control mb-2" onChange={handleImageUpload} />

        {preview && (
          <img src={preview} alt="Preview" className="img-fluid rounded mb-2" style={{ maxHeight: '200px' }} />
        )}

        <button className="btn btn-primary">Add News</button>
      </form>

      <ul className="list-group">
        {news.map(n => (
          <li key={n._id} className="list-group-item d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              {n.image && (
                <img
                  src={n.image}
                  alt={n.title}
                  style={{ width: 56, height: 56, objectFit: 'cover' }}
                  className="rounded me-3"
                />
              )}
              {n.title}
            </div>

            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(n._id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  );
}
